<template>
  <div  v-if="classification && classification.length > 0">
    <div class="newBox">
      <div class="doT-one"></div>
      <div class="doT-two"></div>
      <div class="news" style="width: 1200px;">
        <p class="news-P-one">{{$t("i.jj.jj")}}</p>
        <br />
        <div>
          <!--<Button class="returnBtn" @click="gotoInfo">{{$t("i.jj.btn")}}</Button>-->
          <div class="category1">
            <template v-for="(nav, index) in classification">
              <p :class="index % 2 === 0 ? 'category1-p1' : 'category1-p0' " >
                <a href="javascript:void(0)" @click="gotoInfo(nav)" style="color: white">
                  <span v-html="nav.name"></span>
                </a>
              </p>
            </template>
          </div>
        </div>
       </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "classification",
    computed: {
      ...mapState({
        classification: (state) => state.classification,
      }),
    },
    data(){
      return {
        // nav : {'name':this.$t('i.jj.title1'),'id':'08269cdad00747419514187ff2672eca'}
      }
    },
    methods: {
      gotoInfo(nav) {
          let dataName = nav.name.replace(/<br\/?>/gi, '・');
          this.$router.replace({name: 'classificationInfo',query: {name: dataName, id: nav.id }})
        }
     }
  }


</script>

<style scoped>
  .newBox{
    width: 862px;
    height: 35px;
  }
  .doT-one{
    width: 10px;
    height: 10px;
    background-color: #e50020;
    margin-left: 105px;
    float: left;
  }
  .doT-two{
    width: 10px;
    height: 10px;
    background-color: #a8a8a9;
    margin-left: -10px;
    margin-top: 20px;
    float: left;
  }
  .news-P-one{
    float: left;
    display: inline;
    margin-left: 15px;
    font-size: 30px;
    margin-top: -8px;
  }


  .category1 {
    *zoom: 1; /* IE6-7 清除浮动，IE11也兼容 */
    padding: 10px;
    margin-top: 15px;
    margin-left: -50px;
    width: 600px;
    float: left;
    position: relative;
  }

  .category1::after {
    content: "";
    display: table;
    clear: both;
  }

  /* p标签样式 */
  .category1-p1 {
    width: 300px;
    height: 90px;
    float: left;
    width: 48%; /* 控制宽度，留出行间距 */
    margin: 0 0 15px 0;
    padding: 10px;
    background-color: #8FAADC;
    font-size: 18px;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 10px;
  }

  /* p标签样式 */
  .category1-p0 {
    width: 300px;
    height: 90px;
    float: left;
    width: 48%; /* 控制宽度，留出行间距 */
    margin: 0 0 15px 0;
    padding: 10px;
    background-color: #70AD47;
    font-size: 18px;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 10px;
  }

  /* 为奇数p标签添加右侧间距，实现两个一行 */
  .category1 p:nth-child(2n+1) {
    margin-right: 4%; /* 两个p标签之间的间距 */
  }

  /* 响应式调整 - 小屏幕显示一行 */
  @media screen and (max-width: 600px) {
    .p-wrapper p {
      float: none;
      width: 100%;
      margin-right: 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/classification/classification.vue